<template>
  <a-modal
    title="Confirmation"
    :visible="modalEdit"
    v-if="modalEdit"
    @cancel="handleCancel"
  >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          Cancel
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleModalEditOk">
          OK
        </a-button>
      </template>
    <!-- <a-alert
      message="Exceeded limit Value"
      :description="'Your report has exceeded the limit of ' + limitasi"
      type="error"
      closable
      v-if="errorText"
      @close="alertClose"
    /> -->
    <a-spin :spinning="data.pageloading" tip="Loading...">
      <a-form :form="formEdit">
        <a-form-item label="UM Detail">
          <a-select
            showSearch
            allowClear
            @search="handleppdtl"
            @change="handleChangeumDtl"
            v-decorator="['um_dtl', {rules: [{required: true}], initialValue: data.selected_um_dtl}]"
          >
            <a-select-option
              v-for="item in data.ppdetillist"
              :key="item.id_um_dtl"
            >
            <!-- <table style="width:100%">
              <tr>
                <td>
                  <span> {{item.item_nm}}</span>
                </td>
                <td>
                  <b style="float:right">&nbsp;&nbsp;&nbsp;{{formatCurrency(item.currency,parseFloat(item.saldo_um))}} </b>
                </td>
              </tr>
            </table> -->
            <div class="elipsdiv">
              <div class="elipsdiv-mouseover-label1" >
                {{ item.item_nm }}</div>
              <div class="elipsdiv-mouseover-label2">
                  <b style="float: right">{{
                      formatCurrency(item.currency,parseFloat(item.saldo_um))
                    }}
                  </b>
              </div>
            </div>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Usage date">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal_pemakaian',
              {
                rules: [{ required: true }],
                initialValue: moment(data.tanggal_pemakaian),
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Description">
          <a-input
            v-decorator="[
              'deskripsi',
              { rules: [{ required: true }], initialValue: data.deskripsi },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Credit">
          <a-input-number
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="[
              'kredit',
              {
                rules: [{ required: false }, { validator: checkPrice }],
                initialValue: data.kredit,
              },
            ]"
          />
        </a-form-item>
        <a-row :gutter="12">
            <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: data.iscommision },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: data.without_note },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
        </a-row>
        <a-form-item label="Upload Transaction Document">
          <a-upload
            :showUploadList="true"
            :fileList="doctransfiles"
            :beforeUpload="beforedoctransUpload"
            :remove="handledoctransRemove"
            v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
          >
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  props: {
    modalEdit: Boolean,
    data: {},
  },
  mixins: [CurrencyFormat],
  computed: {
    ...mapGetters(["getDefaultDateFormat", "getAuth", "getScreen"]),
  },
  data() {
    return {
      pageLoading:true,
      confirmLoading: false,
      //errorText: false,
      limitasi: this.data.debit + this.data.limitasi,
      EnCommission: false,
      Viwithout_note: false,
      doctransfiles: [],
    };
  },
  beforeCreate() {
    this.formEdit = this.$form.createForm(this);
  },
  watch:{
    data(){
      if(this.data.id){
        // this.EnCommission = this.data.EnCommission;
        this.Viwithout_note = this.data.Viwithout_note;
        this.doctransfiles = this.data.doctransfiles;
      }
    }
  },
  methods: {
    moment,
    handleppdtl(e){
    },
    alertClose() {
      //this.errorText = false;
    },
    handleCancel(e) {
      //this.errorText = false;
      Event.$emit("modalCancel", false);
      this.formEdit.resetFields();
    },
    handleModalEditOk() {
      this.formEdit.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Usage date can't exceed today!");
          return;
        }

        // const counting_value =
        // this.data.totalKreditSebelum -
        // parseInt(this.data.kredit) +
        // parseInt(values.kredit);
        // console.log("counting_value",counting_value,this.data.limitasi)
        // if (counting_value > this.data.limitasi) {
        //   //this.errorText = true;
        //   this.displayMessageValue("error-other","exceeds the limit PP! (max value: "+this.data.limitasi+")")
        //   this.limitasi = this.data.limitasi;
        //   return;
        // } else {
        // console.log("axios",counting_value)

          let addData = new FormData();
          addData.append("id", this.data.id);
          addData.append("tanggal_pemakaian", values.tanggal_pemakaian.format("YYYY-MM-DD"));
          addData.append("deskripsi", values.deskripsi);
          addData.append("kredit", values.kredit);
          addData.append("um_dtl", values.um_dtl);
          addData.append("iscommision", values.iscommision);
          //addData.append("without_note", values.without_note);
          addData.append("without_note", "1");
          if (this.doctransfiles && this.doctransfiles.length > 0) {
            this.doctransfiles.forEach((file) => {
              addData.append("file_upload", file);
            });
          }

          this.confirmLoading = true;
          let url =
            this.data.type === "revised"
              ? "lap_um_pp/revisi_detil_pemakaian_edit"
              : "lap_um_pp/detil_pemakaian_edit";

          axios({
            method: "post",
            url: this.$serviceUrl + url,
            processData: false,
            data: addData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              // "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.confirmLoading = false;
              this.formEdit.resetFields();
              //this.errorText = false;
              Event.$emit("modalCancel", false);
              Event.$emit("fetchPemakaian", true);
            })
            .catch((err) => {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
              this.confirmLoading = false;
              console.log("error : " + err);
            });
        // }
      });
    },
    checkPrice(rule, value, callback) {
      if (value >= 0) {
        callback();
        return;
      }
      callback("Price must same or greater than zero!");
    },
    setfalseLoading(){
      this.pageLoading = false
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.formEdit.setFieldsValue({
            without_note: "1",
        });
      });
    },
    handleChangeumDtl(val){
      let selectedumDtl = _.filter(this.data.ppdetillist, { id_um_dtl: val });
      //console.log(selectedumDtl,this.ppdetillist);
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        // this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        // this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
  },
};
</script>

<style lang="less">
.select {
  &-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > div {
      display: flex;
      gap: @padding / 2;
    }
  }
  &-between {
    .ant-select-selection {
      width: 100%;
      display: flex;
      justify-content: space-between;
      float:unset!important;
      &__rendered {
        flex: 1;
        padding-right: @padding;
        display: flex;
        float:unset!important;
      }
      &-selected-value {
        flex: 1;
        float:unset!important;
      }
    }
  }
}

.ant-select-selection-selected-value{
    width:100%!important;
    .elipsdiv{
      .elipsdiv-mouseover-label1:hover{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>